export default __webpack_public_path__ + "static/media/testimonial_vector_top.342c042f.svg";